import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getMouldRisk = async (projectId, deviceId) => {
  const apiPath = `projects/${projectId}/renolog/devices/${deviceId}/mould-risk`;
  const signedRequest = await createSignedGetRequest({
    apiPath,
  });
  const response = await axios(signedRequest);
  return response.data;
};
